/**
 * Logger utility for SpriteTool
 * Provides conditional logging based on environment (dev vs production)
 *
 * @module utils/logger
 */

const DEBUG = import.meta.env.DEV;

/**
 * Centralized logger with environment-aware output
 * - In development: all logs are output with [SpriteTool] prefix
 * - In production: only errors are output
 */
export const logger = {
  /**
   * Log informational messages (dev only)
   * @param {...any} args - Arguments to log
   */
  log(...args) {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.log('[SpriteTool]', ...args);
    }
  },

  /**
   * Log warning messages (dev only)
   * @param {...any} args - Arguments to log
   */
  warn(...args) {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.warn('[SpriteTool]', ...args);
    }
  },

  /**
   * Log error messages (always output, even in production)
   * @param {...any} args - Arguments to log
   */
  error(...args) {
    // eslint-disable-next-line no-console
    console.error('[SpriteTool]', ...args);
  },

  /**
   * Log debug messages with additional context (dev only)
   * @param {string} context - Context identifier (e.g., 'STORAGE', 'SPRITE_EDITOR')
   * @param {...any} args - Arguments to log
   */
  debug(context, ...args) {
    if (DEBUG) {
      // eslint-disable-next-line no-console
      console.log(`[SpriteTool:${context}]`, ...args);
    }
  },
};
